<template>
  <div class="mt-2">
    <!-- start: page -->
    <div class="tabs">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-bs-target="#details"
            href="#details"
            data-bs-toggle="tab"
          >
            Detalji</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-target="#my-articles"
            href="#my-articles"
            data-bs-toggle="tab"
            >Proizvodi</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-target="#super-bonus"
            href="#super-bonus"
            data-bs-toggle="tab"
            >Super bonus</a
          >
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" data-bs-target="#addresses" href="#addresses" data-bs-toggle="tab">Adrese</a>
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" data-bs-target="#price-policy" href="#price-policy" data-bs-toggle="tab">Politika cijena</a>
        </li> -->
      </ul>
      <div class="tab-content">
        <div id="details" class="tab-pane active">
          <form
            class="ecommerce-form action-buttons-fixed"
            @submit.prevent="submitForm"
          >
            <div class="row">
              <div class="col">
                <section class="card card-modern card-big-info">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-2-5 col-xl-1-5">
                        <i class="card-big-info-icon bx bx-slider"></i>
                        <h2 class="card-big-info-title">
                          {{ translations.details }}
                        </h2>
                        <p class="card-big-info-desc">
                          {{ translations.detailsInfo }}
                        </p>
                      </div>
                      <div class="col-lg-3-5 col-xl-4-5">
                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.title.$invalid &&
                              $v.company.title.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Naziv *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.title"
                              placeholder="Naziv"
                            />

                            <form-error
                              :model="$v.company.title"
                              :dirty="$v.$dirty"
                              label="Naziv *"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Nadredjena kompanija</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <select
                              class="form-control form-control-modern"
                              v-model="company.parentCompanyId"
                            >
                              <option :value="null">Izaberite kompaniju</option>
                              <option
                                :value="item.id"
                                :key="item.id"
                                v-for="item in companies"
                              >
                                {{ item.title }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Opis</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <textarea
                              class="form-control form-control-modern"
                              v-model="company.description"
                            ></textarea>
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.paymentTypes.$invalid &&
                              $v.company.paymentTypes.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Zadani način plaćanja *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <div
                              :class="{
                                has__error: $v.company.paymentTypes.$anyError,
                              }"
                            >
                              <treeselect
                                v-model="company.paymentTypes"
                                :multiple="true"
                                :options="paymentTypes"
                                :show-count="true"
                              />
                            </div>

                            <form-error
                              :model="$v.company.paymentTypes"
                              :dirty="$v.$dirty"
                              label="Zadani način plaćanja *"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Država *</label
                          >
                          <div class="col-lg-7 col-xl-6" v-if="loaded">
                            <treeselect
                              v-model="company.countryId"
                              loadingText="Učitavanje..."
                              noResultsText="Nema rezultata"
                              searchPromptText="Unesite državu"
                              :load-options="loadCountries"
                              :options="countries"
                              :default-options="countries"
                              :cache-options="false"
                              :async="true"
                              placeholder="Izaberite državu"
                              @select="getTowns"
                            />

                            <form-error
                              :model="$v.company.countryId"
                              :dirty="$v.$dirty"
                              label="Država *"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.townId.$invalid &&
                              $v.company.townId.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Grad *</label
                          >
                          <div class="col-lg-7 col-xl-6" v-if="loaded">
                            <treeselect
                              v-model="company.townId"
                              loadingText="Učitavanje..."
                              noResultsText="Nema rezultata"
                              searchPromptText="Unesite grad"
                              :load-options="loadTowns"
                              :cache-options="false"
                              :async="true"
                              :options="towns"
                              :default-options="towns"
                              placeholder="Izaberite grad"
                            />

                            <form-error
                              :model="$v.company.townId"
                              :dirty="$v.$dirty"
                              label="Grad *"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Komercijalista</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <select
                              class="form-control form-control-modern"
                              v-model="company.commercialistId"
                            >
                              <option :value="null">
                                Izaberite komercijalistu
                              </option>
                              <option
                                :value="item.id"
                                :key="item.id"
                                v-for="item in commercialists"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row align-items-center pb-3"
                        :class="{
                            'has-danger':
                              $v.company.masterId.$invalid &&
                              $v.company.masterId.$dirty,
                          }">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Master kompanija *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <select
                              class="form-control form-control-modern"
                              v-model="company.masterId"
                            >
                              <option :value="null">
                                Izaberite master kompaniju
                              </option>
                              <option
                                :value="item.id"
                                :key="item.id"
                                v-for="item in masterCompanies"
                              >
                                {{ item.title }}
                              </option>
                            </select>

                            <form-error
                              :model="$v.company.masterId"
                              :dirty="$v.$dirty"
                              label="Master kompanija *"
                            />
                          </div>
                        </div>
                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Besplatna dostava nakon iznosa</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.freeShippingForOrdersOver"
                            />
                          </div>
                        </div>
                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.code.$invalid &&
                              $v.company.code.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Kôd *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.code"
                              placeholder="Kôd"
                            />

                            <form-error
                              :model="$v.company.code"
                              :dirty="$v.$dirty"
                              label="Kôd *"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.address.$invalid &&
                              $v.company.address.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Adresa *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.address"
                              placeholder="Adresa"
                            />

                            <form-error
                              :model="$v.company.address"
                              :dirty="$v.$dirty"
                              label="Adresa *"
                            />
                          </div>
                        </div>

                        <!-- <div
                          class="form-group row align-items-center pb-3"
                          :class="{ 'has-danger': $v.company.discount.$invalid && $v.company.discount.$dirty }">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Discount</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.discount"
                            />
                          </div>
                        </div> -->

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.email.$invalid &&
                              $v.company.email.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >E-mail *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="email"
                              class="form-control form-control-modern"
                              v-model="company.email"
                              placeholder="E-mail"
                            />

                            <form-error
                              :model="$v.company.email"
                              :dirty="$v.$dirty"
                              label="E-mail *"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.phone.$invalid &&
                              $v.company.phone.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Telefon *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.phone"
                              placeholder="Telefon"
                            />

                            <form-error
                              :model="$v.company.phone"
                              :dirty="$v.$dirty"
                              label="Telefon *"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Fax</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.fax"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Web stranica</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="url"
                              class="form-control form-control-modern"
                              v-model="company.web"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.idNumber.$invalid &&
                              $v.company.idNumber.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Id broj *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.idNumber"
                              placeholder="Id broj"
                            />

                            <form-error
                              :model="$v.company.idNumber"
                              :dirty="$v.$dirty"
                              label="Id broj *"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Broj PDV-a *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.vatNumber"
                              placeholder="Broj PDV-a"
                            />

                            <form-error
                              :model="$v.company.vatNumber"
                              :dirty="$v.$dirty"
                              label="Broj PDV-a *"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center pb-3"
                          :class="{
                            'has-danger':
                              $v.company.delayedPaymentInDays.$invalid &&
                              $v.company.delayedPaymentInDays.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Rok plaćanja za kupca *</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              v-model="company.delayedPaymentInDays"
                              placeholder="Rok plaćanja za kupca"
                            />
                            <form-error
                              :model="$v.company.delayedPaymentInDays"
                              :dirty="$v.$dirty"
                              label="Rok plaćanja za kupca *"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                          >
                            Prikaz rabata?
                          </label>
                          <div class="col-lg-7 col-xl-6">
                            <div class="checkbox-custom checkbox-default">
                              <input
                                type="checkbox"
                                v-model="company.discountDataVisible"
                                id="discount-data-visible"
                              />
                              <label for="discount-data-visible"></label>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                          >
                            Artikli uvijek vidljivi na webu?
                          </label>
                          <div class="col-lg-7 col-xl-6">
                            <div class="checkbox-custom checkbox-default">
                              <input
                                type="checkbox"
                                v-model="company.articleAlwaysVisibleOnWeb"
                                id="article-always-visible-on-web"
                              />
                              <label
                                for="article-always-visible-on-web"
                              ></label>
                            </div>
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center mb-3"
                          v-if="company.imageUrl"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                          >
                            Slika
                          </label>
                          <div class="col-lg-7 col-xl-6">
                            <div class="popup-gallery row">
                              <div class="img-fluid">
                                <img
                                  class="img-thumbnail"
                                  :src="`${baseUrl}${company.imageUrl}`"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Slika/logo</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="file"
                              class="form-control form-control-modern"
                              ref="photo"
                              @change="handlePhotoUpload"
                              accept="image/*"
                            />
                            <span class="form-text">
                              Učitajte sliku rezolucije 400px x 320px
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="card card-modern card-big-info mt-2"
                  v-if="posterUrl || company.imageUrl"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-2-5 col-xl-1-5">
                        <i class="card-big-info-icon bx bx-slider"></i>
                        <h2 class="card-big-info-title">Company photo</h2>
                      </div>
                      <div class="col-lg-3-5 col-xl-4-5">
                        <div class="form-group row align-items-center mb-3">
                          <img v-if="posterUrl" :src="posterUrl" />
                          <img
                            :src="`${baseUrl}${company.imageUrl}`"
                            v-if="company.imageUrl && !posterUrl"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div class="action-buttons d-flex justify-content-between">
              <div>
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                  class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                >
                  <i class="bx bx-trash text-4 me-2"></i>
                  {{ translations.delete }}
                </button>
              </div>
              <div class="d-flex gap-3">
                <router-link
                  exact
                  :to="{ name: 'Companies' }"
                  class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                >
                  {{ translations.cancel }}
                </router-link>
                <button
                  type="submit"
                  class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                  data-loading-text="Loading..."
                >
                  <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- novi superbonus -->
        <div id="super-bonus" class="tab-pane">
          <div class="row">
            <div class="col">
              <div class="card card-modern">
                <div class="card-body">
                  <div class="datatables-header-footer-wrapper">
                    <div class="datatable-header">
                      <div class="row align-items-center mb-3">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                          <router-link
                            class="
                              btn btn-primary btn-md
                              font-weight-semibold
                              btn-py-2
                              px-4
                            "
                            :to="{ name: 'AddSuperBonus', params: {companyId: this.$route.params.companyId, superbonusid: this.$route.params.superbonusid} }"
                            >+ Dodaj super bonus</router-link
                          >
                        </div>
                        <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                        </div>
                        <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                          <div class="d-flex align-items-lg-center flex-column flex-lg-row">
                            <label class="ws-nowrap me-3 mb-0">Show:</label>
                            <select
                              class="form-control select-style-1 results-per-page"
                              name="results-per-page"
                              v-model="searchConfig.pageSize"
                              @change="changePageSize(searchConfig.pageSize)"
                            >
                              <option
                                :value="page"
                                v-for="page in pageSizeList"
                                :key="page"
                              >{{ page }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12 col-lg-auto ps-lg-1">
                          <div class="search search-style-1 search-style-1-lg mx-lg-auto">
                            <div class="input-group">
                              <input
                                type="text"
                                class="search-term form-control"
                                placeholder="Search"
                                v-model="searchField"
                                @input="debounceInput"
                              />
                              <button class="btn btn-default" type="submit">
                                <i class="bx bx-search"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                    <div class="dataTables_wrapper dt-bootstrap5 no-footer" v-if="list?.length > 0">
                      <div class="table-responsive">
                        <table
                          class="
                            table table-ecommerce-simple table-striped
                            mb-0
                            dataTable
                            no-footer
                          "
                        >
                          <thead>
                            <tr role="row">
                              <th width="3%" class="sorting_disabled">
                                <input
                                  type="checkbox"
                                  class="select-all checkbox-style-1 p-relative top-2"
                                  v-model="selectAll"
                                />
                              </th>
                              <th class="sorting">Rbr</th>
                              <th class="sorting">Datum od</th>
                              <th class="sorting">Datum do</th>
                              <th class="sorting">Datum kreiranja</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              role="row"
                              v-for="(itemFromList, index) in list"
                              :key="itemFromList.id"
                              @click="openDetails(itemFromList.id)"
                              :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                            >
                              <td width="30">
                                <input
                                  type="checkbox"
                                  class="checkbox-style-1 p-relative top-2"
                                  :value="itemFromList.id"
                                  v-model="selected"
                                  @click.stop
                                />
                              </td>
                              <td>
                                  <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                              </td>
                              <td>{{ formatDate(itemFromList.dateFrom) }}</td>
                              <td>{{ formatDate(itemFromList.dateTo) }}</td>
                              <td>{{ formatDate(itemFromList.createdDate) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else>
                      <div class="alert alert-info" role="alert">
                        {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <modal id="delete-modal">
              <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
              <div slot="body">
                <span v-html="articleModalText">
                </span>
              </div>
              <div slot="footer">
                <div class="row">
                  <div class="col-md-12 text-end">
                    <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
                      {{ translations.yes }}
                    </button>
                    <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                      {{ translations.no }}
                    </button>
                  </div>
                </div>
              </div>
            </modal>
            <!-- end: page -->
          </div>
        </div>
        <!-- kraj novi superbonus -->

        <div id="my-articles" class="tab-pane">
          <company-articles />
        </div>
        <!-- <div id="addresses" class="tab-pane">
          <addresses />
          <new-address />
        </div> -->
        <!-- <div id="price-policy" class="tab-pane">
          <price-policy />
        </div> -->
        <modal id="delete-modal">
          <h5 slot="header">
            <strong>{{ translations.deleteCompany }}</strong>
          </h5>
          <div slot="body">
            <span v-html="modalText"> </span>
          </div>
          <div slot="footer">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  type="button"
                  class="btn btn-primary px-4 mx-2"
                  @click.prevent.stop="deleteCompany"
                  data-bs-dismiss="modal"
                >
                  {{ translations.yes }}
                </button>
                <button
                  type="button"
                  class="btn btn-default px-4"
                  data-bs-dismiss="modal"
                >
                  {{ translations.no }}
                </button>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </div>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';
import { format } from 'date-fns';

import { translations, pager } from '@/mixins';
import validations from './validation-schema/add';
// import Pagination from '../shared/Pagination.vue';
import api from '@/services/api';
import config from '@/config';
import helpers from '@/services/helpers';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';
import CompanyArticles from './Articles.vue';
// import Addresses from './Addresses.vue';
// import NewAddress from './NewAddress.vue';
// import PricePolicy from '@/views/price-policies/Add.vue';

const currentDate = new Date();
const toDate = new Date();
toDate.setDate(currentDate.getDate() + 365);
export default {
  name: 'EditCompany',
  mixins: [translations, pager],
  components: {
    Treeselect,
    FormError,
    // Pagination,
    Modal,
    CompanyArticles,
    // Addresses,
    // NewAddress,
    // PricePolicy,
  },
  validations: {
    company: {
      ...validations,
    },
  },
  data() {
    return {
      posterUrl: null,
      baseUrl: config.baseUrl,
      loaded: false,
      selected: [],
      actionName: "getCompanySuperBonusPaged",
      deleteActionName: 'deleteCompanies',
      bulkActionName: 'deleteCompanies',
    };
  },
  computed: {
    articleModalText() {
      return this.translations.areYouSureSelected;
    },
    bs() {
      return bs;
    },
    paymentTypes() {
      return helpers.paymentTypesArray;
    },
    modalText() {
      return this.translations.areYouSureCompany.replace(
        '{company}',
        `<strong>${this.company.title}</strong>`
      );
    },
    company() {
      return this.$store.getters.getCompany;
    },
    list() {
      return this.$store.getters.getCompanySuperBonusPaged || [];
    },
    isFormValid() {
      return !this.$v.company.$invalid;
    },
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    commercialists() {
      return this.$store.getters.getCommercialists;
    },
    masterCompanies() {
      return this.$store.getters.getMasterCompanies;
    },
    companies() {
      return this.$store.getters.getSimplifiedCompanies;
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, {
            sortBy: 'dateFrom',
            isSortAscending: true,
            retrieveAll: true,
            companyId: this.$route.params.companyId,
          })
    this.$store.dispatch('getCommercialists');
    this.$store.dispatch('getMasterCompanies');
    this.$store.dispatch('getSimplifiedCompanies', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store
      .dispatch('getCompany', this.$route.params.companyId)
      .then((response) => {
        Promise.all([
          this.$store.dispatch('getCountries', {
            sortBy: 'title',
            isSortAscending: true,
            retrieveAll: true,
            mustIncludeId: response.countryId,
          }),
          this.$store.dispatch('getTowns', {
            sortBy: 'title',
            isSortAscending: true,
            retrieveAll: true,
            countryId: response.countryId,
            mustIncludeId: response.townId,
          }),
        ])
          .then(() => {
            this.loaded = true;
          })
          .catch((err) => {
            this.$toast.error(err.response.data.info);
          });
      });
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditSuperBonus', params: { companyId: this.$route.params.companyId, superbonusid: id } });
    },
    submitForm() {
      this.$v.company.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { company } = this;

      if (this.$refs.photo.files[0]) {
        company.image = {
          file: this.posterUrl.split(',')[1],
          fileName: this.$refs.photo.files[0].name,
        };
      }

      api
        .updateCompany(company)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Companies' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    getTowns({ id }) {
      this.$store.dispatch('getTowns', { countryId: id });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.posterUrl = e.target.result;
      };
    },
    deleteCompany() {
      api
        .deleteCompanies([this.company.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Companies' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Companies' });
        });
    },
    loadTowns({ callback, searchQuery }) {
      this.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.company.countryId,
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    loadCountries({ callback, searchQuery }) {
      this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
    },
  },
};
</script>

<style lang="scss">
.tab-content {
  background: transparent;
  padding: 0;
  box-shadow: none;
  border: none;
}
</style>

<style scoped>
.super-bonus-program {
  top: -15px;
  width: 100%;
  position: relative;
}

.progress-bar-container {
  position: relative;
  height: 100px; /* Adjusted to make room for larger circles */
}

.progress-bar {
  height: 18px;
  background-color: #e0e0e0;
  border-radius: 2px;
  position: relative;
  top: 30px; /* Positions the bar below the circles */
}

.progress-fill {
  height: 100%;
  background-color: #007bff;
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease;
}

.milestone {
  position: absolute;
  top: 10; /* Ensures the circles are above the bar */
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.milestone-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(145deg, #ffffff, #e6e6e6); /* Light 3D effect */
  border: 2px solid #ffffff;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15), -2px -2px 4px rgba(255, 255, 255, 0.8); /* Soft shadow for 3D */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
  position: relative;
  z-index: 2;
  transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
}

.milestone-circle.active {
  background: linear-gradient(145deg, #fff, #fff); /* Active gradient */
  color: #007bff; /* White text for active state */
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25), -2px -2px 6px rgba(255, 255, 255, 0.5); /* Enhanced shadow for active state */
}

.milestone-value {
  margin-top: 5px; /* Adds spacing between the circle and the percentage text */
  font-size: 12px;
  font-weight: bold;
  color: #333; /* Neutral color for percentage text */
}
</style>

